var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mt-5" }, [
        _c("div", { staticClass: "row justify-content-center text-left" }, [
          _c("div", { staticClass: "col-md-12 " }, [
            _vm.proccess == "START" && _vm.hasPrev
              ? _c("h3", { staticClass: "Regular pt-2 h0 widthFull" }, [
                  _c("b", [_vm._v("Calcolatore preventivi")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.proccess == "START" && !_vm.hasPrev
              ? _c("h3", { staticClass: "Regular pt-2 h0 widthFull" }, [
                  _c("b", [_vm._v("Crea la pratica")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.proccess == "START" && _vm.hasPrev
              ? _c("p", { staticClass: "black mt-0 text-left widthFull" }, [
                  _vm._v(
                    "\r\n          Compila i seguenti step. In caso di conferma del preventivo tutti\r\n          i dati inseriti verranno poi utilizzati per generare i documenti richiesti per lo sconto in fattura.\r\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.proccess == "START" && !_vm.hasPrev
              ? _c("p", { staticClass: "black mt-0 text-left widthFull" }, [
                  _vm._v("\r\n          Compila i seguenti step.\r\n        ")
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5" }, [
          _vm.proccess == "START"
            ? _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont pt-1 mt-0",
                  staticStyle: { "margin-top": "0!important" }
                },
                [
                  _c(
                    "form-wizard",
                    {
                      staticClass: "mt-0 pb-2 formp ",
                      attrs: {
                        title: "",
                        subtitle: "",
                        nextButtonText: "Avanti >",
                        backButtonText: "< Indietro",
                        finishButtonText: "Salva pratica",
                        stepSize: _vm.stepSize,
                        color: "#00337f",
                        errorColor: "#ff1100"
                      },
                      on: {
                        "on-change": _vm.stepIndex,
                        "on-complete": _vm.onComplate
                      }
                    },
                    [
                      3 == 3
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Scegli Bonus",
                                icon: "",
                                "before-change": _vm.validateZeroTab
                              }
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "widthFull",
                                  attrs: {
                                    "data-vv-scope": "form-0",
                                    autocomplete: "qwerqrt2"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center pb-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 mb-2 " },
                                        [
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "pb-0 center Bold theme uppercase"
                                            },
                                            [
                                              _vm._v(
                                                "Clicca sull`icona del bonus a cui vuoi associare la pratica"
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus ==
                                                  "Bonus Casa 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Bonus Casa 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Bonus Casa 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                      Se vuoi aderire al\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Bonus Casa 50%\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\r\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Bonus Casa 50%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: require("../../assets/images/50.png")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: require("../../assets/images/50w.png")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Bonus Casa 50%"
                                                  }
                                                },
                                                [_vm._v(" Bonus Casa")]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6  col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                      Se vuoi aderire al\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Ecobonus 50%\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\r\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Ecobonus 50%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: require("../../assets/images/50.png")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: require("../../assets/images/50w.png")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 50%"
                                                  }
                                                },
                                                [_vm._v(" Ecobonus")]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 65%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 65%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 65%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                      Se vuoi aderire al\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Ecobonus 65%\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\r\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Ecobonus 65%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: require("../../assets/images/65.png")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: require("../../assets/images/65w.png")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 65%"
                                                  }
                                                },
                                                [_vm._v(" Ecobonus")]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3",
                                          staticStyle: { display: "none" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.ecoBonus,
                                                    expression: "ecoBonus"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: true,
                                                      max: 63,
                                                      min: 2
                                                    },
                                                    expression:
                                                      "{required:true, max: 63, min: 2}"
                                                  }
                                                ],
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-0.ecoBonus"
                                                  ),
                                                  valid: !!_vm.ecoBonus
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "ecobonus",
                                                  name: "ecobonus",
                                                  "data-vv-as": "ecoBonus"
                                                },
                                                domProps: {
                                                  value: _vm.ecoBonus
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.ecoBonus =
                                                      $event.target.value
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3 center"
                                        },
                                        [
                                          _vm.errors.has("form-0.ecobonus")
                                            ? _c(
                                                "div",
                                                { staticClass: "red" },
                                                [
                                                  _c(
                                                    "b",
                                                    { staticClass: "h5 red" },
                                                    [
                                                      _vm._v(
                                                        "Per procedere devi selezionare una tra le tre icone sopraindicate. "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 mb-3 " },
                                        [
                                          _vm._v(
                                            "\r\n                  Novatag e KPMG,  \r\n                  non si ritengono responsabili per eventuali danni economici \r\n                  derivanti dall.utilizo della piattaforma e dall.informazioni fornite."
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      3 == 3
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Seleziona l'istallatore",
                                icon: "",
                                "before-change": _vm.validateInst
                              }
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "widthFull",
                                  attrs: {
                                    "data-vv-scope": "form-0",
                                    autocomplete: "qwerqrt2"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-12 center" },
                                        [
                                          _c(
                                            "h1",
                                            { staticClass: "Bold theme" },
                                            [
                                              _vm._v(
                                                "Seleziona l'istallatore a cui associare la pratica"
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-lg-5 col-md-6 col-12"
                                        },
                                        [
                                          _vm.selectready
                                            ? _c("v-select", {
                                                key: 1,
                                                attrs: {
                                                  options: _vm.usersForAdmin,
                                                  type: "text",
                                                  placeholder: "Seleziona..."
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.selectChange(
                                                      _vm.userSel
                                                    )
                                                  }
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "search",
                                                      fn: function(ref) {
                                                        var attributes =
                                                          ref.attributes
                                                        var events = ref.events
                                                        return [
                                                          _c(
                                                            "input",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "vs__search",
                                                                  attrs: {
                                                                    required:
                                                                      _vm.userSel
                                                                  }
                                                                },
                                                                "input",
                                                                attributes,
                                                                false
                                                              ),
                                                              events
                                                            )
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  1550066045
                                                ),
                                                model: {
                                                  value: _vm.userSel,
                                                  callback: function($$v) {
                                                    _vm.userSel = $$v
                                                  },
                                                  expression: "userSel"
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.seleErr
                                            ? _c(
                                                "small",
                                                { staticClass: "red Bold" },
                                                [_vm._v("Il campo è richiesto")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-12" }),
                                      _vm._v(" "),
                                      _vm.selectionOk
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "col-12 center mb-3"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "center theme Bold"
                                                },
                                                [
                                                  _vm._v(
                                                    "Di seguito l'anagrafica dell'istallatore selezionato:"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("img", {
                                                staticClass:
                                                  "img img-fluid mt-5 imgIco mb-3",
                                                staticStyle: {
                                                  "max-width": "150px"
                                                },
                                                attrs: {
                                                  src: require("../../assets/images/user-ico.png")
                                                }
                                              }),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "uppercase Bold theme"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.referSel.name) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.referSel.cognome
                                                      )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.email
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel.email,
                                                        expression:
                                                          "referSel.email"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.email"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .email
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.email",
                                                      name: "referSel.email",
                                                      "data-vv-as": "Email"
                                                    },
                                                    domProps: {
                                                      value: _vm.referSel.email
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "email",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "referSel.email"
                                                      }
                                                    },
                                                    [_vm._v("Email")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.email"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.email"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.azienda
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel.azienda,
                                                        expression:
                                                          "referSel.azienda"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.azienda"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .azienda
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.azienda",
                                                      name: "referSel.azienda",
                                                      "data-vv-as": "Azienda"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.azienda
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "azienda",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "referSel.email"
                                                      }
                                                    },
                                                    [_vm._v("Azienda")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.azienda"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.azienda"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk &&
                                      _vm.referSel.partita_iva
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel
                                                            .partita_iva,
                                                        expression:
                                                          "referSel.partita_iva"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.partita_iva"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .partita_iva
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id:
                                                        "referSel.partita_iva",
                                                      name:
                                                        "referSel.partita_iva",
                                                      "data-vv-as":
                                                        "Partita IVA"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.partita_iva
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "partita_iva",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "referSel.partita_iva"
                                                      }
                                                    },
                                                    [_vm._v("Partita IVA")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.partita_iva"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.partita_iva"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk &&
                                      _vm.referSel.codice_fiscale
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel
                                                            .codice_fiscale,
                                                        expression:
                                                          "referSel.codice_fiscale"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.codice_fiscale"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .codice_fiscale
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id:
                                                        "referSel.codice_fiscale",
                                                      name:
                                                        "referSel.codice_fiscale",
                                                      "data-vv-as":
                                                        "Codice Fiscale"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel
                                                          .codice_fiscale
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "codice_fiscale",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "referSel.codice_fiscale"
                                                      }
                                                    },
                                                    [_vm._v("Codice Fiscale")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.codice_fiscale"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.codice_fiscale"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.telefono
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel.telefono,
                                                        expression:
                                                          "referSel.telefono"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.telefono"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .telefono
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.telefono",
                                                      name: "referSel.telefono",
                                                      "data-vv-as": "Telefono"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.telefono
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "telefono",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "referSel.telefono"
                                                      }
                                                    },
                                                    [_vm._v("Telefono")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.telefono"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.telefono"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.cellulare
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel
                                                            .cellulare,
                                                        expression:
                                                          "referSel.cellulare"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.cellulare"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .cellulare
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.cellulare",
                                                      name:
                                                        "referSel.cellulare",
                                                      "data-vv-as": "Cellulare"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.cellulare
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "cellulare",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "referSel.cellulare"
                                                      }
                                                    },
                                                    [_vm._v("Cellulare")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.cellulare"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.cellulare"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.emailPEC
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel.emailPEC,
                                                        expression:
                                                          "referSel.emailPEC"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.emailPEC"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .emailPEC
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.emailPEC",
                                                      name: "referSel.emailPEC",
                                                      "data-vv-as": "PEC"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.emailPEC
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "emailPEC",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "referSel.emailPEC"
                                                      }
                                                    },
                                                    [_vm._v("PEC")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.emailPEC"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.emailPEC"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.provincia
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel
                                                            .provincia,
                                                        expression:
                                                          "referSel.provincia"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.provincia"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .provincia
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.provincia",
                                                      name:
                                                        "referSel.provincia",
                                                      "data-vv-as": "Provincia"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.provincia
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "provincia",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "referSel.provincia"
                                                      }
                                                    },
                                                    [_vm._v("Provincia")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.provincia"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.provincia"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.regione
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel.regione,
                                                        expression:
                                                          "referSel.regione"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.regione"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .regione
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.regione",
                                                      name: "referSel.regione",
                                                      "data-vv-as": "Regione"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.regione
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "regione",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "referSel.regione"
                                                      }
                                                    },
                                                    [_vm._v("Regione")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.regione"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.regione"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.comune
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel.comune,
                                                        expression:
                                                          "referSel.comune"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.comune"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .comune
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.comune",
                                                      name: "referSel.comune",
                                                      "data-vv-as": "comune"
                                                    },
                                                    domProps: {
                                                      value: _vm.referSel.comune
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "comune",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "referSel.comune"
                                                      }
                                                    },
                                                    [_vm._v("Comune")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.comune"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.comune"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "col-md-12 mb-3 "
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      3 == 3
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Dati Cliente",
                                icon: "",
                                "before-change": _vm.validateFirstTab
                              }
                            },
                            [
                              _vm.ecoBonus != "Superbonus 110%"
                                ? _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row " }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                    Inserisci i dati del cliente finale\r\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.client_type,
                                                        expression:
                                                          "client_type"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_type"
                                                      ),
                                                      valid: !!_vm.client_type
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      id: "client_type",
                                                      name: "client_type",
                                                      "data-vv-as":
                                                        "Tipologia cliente"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.client_type = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        key: 11,
                                                        attrs: {
                                                          value:
                                                            "Persona fisica"
                                                        }
                                                      },
                                                      [_vm._v("Persona fisica")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.ecoBonus !=
                                                    "Bonus Casa 50%"
                                                      ? _c(
                                                          "option",
                                                          {
                                                            key: 12,
                                                            attrs: {
                                                              value:
                                                                "Partita IVA"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Partita IVA"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_type"
                                                    }
                                                  },
                                                  [_vm._v("Tipologia cliente")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_type"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_type"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.clientName,
                                                      expression: "clientName"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{required:true, max: 63, min: 2}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.clientName"
                                                    ),
                                                    valid: !!_vm.clientName
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "clientName",
                                                    name: "clientName",
                                                    "data-vv-as": "Nome"
                                                  },
                                                  domProps: {
                                                    value: _vm.clientName
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.clientName =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "clientName" }
                                                  },
                                                  [_vm._v("Nome")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.clientName"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.clientName"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.clientLastname,
                                                      expression:
                                                        "clientLastname"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{required:true, max: 63, min: 2}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.clientLastname"
                                                    ),
                                                    valid: !!_vm.clientLastname
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "clientLastname",
                                                    name: "clientLastname",
                                                    "data-vv-as": "Cognome"
                                                  },
                                                  domProps: {
                                                    value: _vm.clientLastname
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.clientLastname =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "clientLastname"
                                                    }
                                                  },
                                                  [_vm._v("Cognome")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.clientLastname"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.clientLastname"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3 " },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_email,
                                                      expression: "client_email"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        email: true,
                                                        temporaryEmail: true,
                                                        plusIssueEmail: true,
                                                        max: 56
                                                      },
                                                      expression:
                                                        "{required:true, email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                                    }
                                                  ],
                                                  ref: "client_email",
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_email"
                                                    ),
                                                    valid: !!_vm.client_email
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_email",
                                                    name: "client_email",
                                                    "data-vv-as": "Email"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_email
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_email =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_email"
                                                    }
                                                  },
                                                  [_vm._v("Email* ")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_email"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_email"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_phone,
                                                      expression: "client_phone"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: false,
                                                        max: 12,
                                                        min: 8,
                                                        regex: /^[0]+/
                                                      },
                                                      expression:
                                                        "{required: false, max: 12, min: 8, regex: /^[0]+/}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_phone"
                                                    ),
                                                    valid: !!_vm.client_phone
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_phone",
                                                    name: "client_phone",
                                                    "data-vv-as": "Telefono"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_phone
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_phone =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_phone"
                                                    }
                                                  },
                                                  [_vm._v("Telefono ")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_phone"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_phone"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_mobile,
                                                      expression:
                                                        "client_mobile"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 12,
                                                        min: 8,
                                                        regex: /^[3]+/
                                                      },
                                                      expression:
                                                        "{required: true, max: 12, min: 8, regex: /^[3]+/}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_mobile"
                                                    ),
                                                    valid: !!_vm.client_mobile
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_mobile",
                                                    name: "client_mobile",
                                                    "data-vv-as": "Cellulare"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_mobile
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_mobile =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_mobile"
                                                    }
                                                  },
                                                  [_vm._v("Cellulare * ")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_mobile"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_mobile"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-4" }, [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              !_vm.person
                                                ? _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.partita_iva,
                                                        expression:
                                                          "partita_iva"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          partitaIva: true,
                                                          max: 11,
                                                          min: 11
                                                        },
                                                        expression:
                                                          "{required:true, partitaIva: true, max: 11, min: 11}"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-control ",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.partita_iva"
                                                      ),
                                                      valid: !!_vm.partita_iva
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "partita_iva",
                                                      name: "partita_iva",
                                                      "data-vv-as":
                                                        "Partita IVA"
                                                    },
                                                    domProps: {
                                                      value: _vm.partita_iva
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.partita_iva =
                                                          $event.target.value
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "highlight"
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "bar"
                                              }),
                                              _vm._v(" "),
                                              !_vm.person
                                                ? _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "partita_iva"
                                                      }
                                                    },
                                                    [_vm._v("Partita IVA *")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.errors.has(
                                                "form-1.partita_iva"
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                " +
                                                          _vm._s(
                                                            _vm.errors.first(
                                                              "form-1.partita_iva"
                                                            )
                                                          ) +
                                                          "\r\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.client_type == "Partita IVA"
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-6 mb-3" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-check" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "group" },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label widthFull black h5",
                                                            attrs: {
                                                              for:
                                                                "usoAbitativo"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                        Prevalente uso abitativo\r\n                      "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline mt-2"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.usoAbitativo = 1
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.usoAbitativo,
                                                                      expression:
                                                                        "usoAbitativo"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "required|included:1,0",
                                                                      expression:
                                                                        "'required|included:1,0'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-1.usoAbitativo"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "1",
                                                                    name:
                                                                      "usoAbitativo"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.usoAbitativo,
                                                                      "1"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo =
                                                                        "1"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v("SI")
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.usoAbitativo = 0
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.usoAbitativo,
                                                                      expression:
                                                                        "usoAbitativo"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-1.usoAbitativo"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "0",
                                                                    name:
                                                                      "usoAbitativo"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.usoAbitativo,
                                                                      "0"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo =
                                                                        "0"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v("NO")
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value: _vm.errors.has(
                                                                  "form-1.usoAbitativo"
                                                                ),
                                                                expression:
                                                                  "errors.has('form-1.usoAbitativo')"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "errorMes red"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                        Il servizio deve essere accettato oppure rifiutato\r\n                      "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.person
                                          ? _c("div", { staticClass: "col-12" })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-4" }, [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _vm.person
                                                ? _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.codice_fiscale,
                                                        expression:
                                                          "codice_fiscale"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          codiceFiscale: true,
                                                          max: 16,
                                                          min: 16
                                                        },
                                                        expression:
                                                          "{required: true, codiceFiscale: true, max: 16, min: 16}"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-control ",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.codice_fiscale"
                                                      ),
                                                      valid: !!_vm.codice_fiscale
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "codice_fiscale",
                                                      name: "codice_fiscale",
                                                      "data-vv-as":
                                                        "Codice Fiscale"
                                                    },
                                                    domProps: {
                                                      value: _vm.codice_fiscale
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.codice_fiscale =
                                                          $event.target.value
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "highlight"
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "bar"
                                              }),
                                              _vm._v(" "),
                                              _vm.person
                                                ? _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "codice_fiscale"
                                                      }
                                                    },
                                                    [_vm._v("Codice Fiscale *")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.existCF
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback",
                                                      staticStyle: {
                                                        display: "block"
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "Codice Fiscale inserito già presente."
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.errors.has(
                                                "form-1.codice_fiscale"
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                " +
                                                          _vm._s(
                                                            _vm.errors.first(
                                                              "form-1.codice_fiscale"
                                                            )
                                                          ) +
                                                          "\r\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black pb-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                    Inserisci l'indirizzo dell'immobile\r\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.province,
                                                        expression: "province"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{required:true}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.province"
                                                      ),
                                                      valid: !!_vm.province
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomy",
                                                      id: "province",
                                                      name: "province",
                                                      "data-vv-as": "Provincia"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.province = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        disabled: "",
                                                        value: "",
                                                        selected: "selected"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.provincies,
                                                      function(province) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: province.sigla,
                                                            domProps: {
                                                              value:
                                                                province.sigla
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                        " +
                                                                _vm._s(
                                                                  province.sigla
                                                                ) +
                                                                " - " +
                                                                _vm._s(
                                                                  province.provincia
                                                                ) +
                                                                "\r\n                      "
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "province" }
                                                  },
                                                  [_vm._v("Provincia")]
                                                ),
                                                _vm._v(" "),
                                                _vm.provinciesState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id:
                                                                "loadProvince",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.province"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.province"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _vm.cityError
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "formError"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Prima scegli Provincia"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.city,
                                                        expression: "city"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{required:true}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.city"
                                                      ),
                                                      valid: !!_vm.city
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomu",
                                                      id: "city",
                                                      name: "city",
                                                      "data-vv-as": "Località",
                                                      disabled: _vm.citiesState
                                                    },
                                                    on: {
                                                      click: _vm.checkProvince,
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.city = $event.target
                                                          .multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        disabled: "",
                                                        value: "",
                                                        selected: "selected"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(_vm.cities, function(
                                                      city
                                                    ) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: city.comune,
                                                          domProps: {
                                                            value: {
                                                              cityistat:
                                                                city.istat,
                                                              city: city.comune
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                        " +
                                                              _vm._s(
                                                                city.comune
                                                              ) +
                                                              "\r\n                      "
                                                          )
                                                        ]
                                                      )
                                                    })
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "city" }
                                                  },
                                                  [_vm._v("Località")]
                                                ),
                                                _vm._v(" "),
                                                _vm.citiesState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id: "loadCity",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.city")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.city"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _vm.zipError
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "formError"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Prima scegli città"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.zip,
                                                        expression: "zip"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{required:true}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.zip"
                                                      ),
                                                      valid: !!_vm.zip
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomi",
                                                      id: "zip",
                                                      name: "zip",
                                                      "data-vv-as": "Cap",
                                                      disabled: _vm.zipsState
                                                    },
                                                    on: {
                                                      click: _vm.checkZip,
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.zip = $event.target
                                                          .multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        value: "",
                                                        disabled: ""
                                                      },
                                                      domProps: {
                                                        selected: true
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(_vm.zips, function(
                                                      zip
                                                    ) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: zip.cap,
                                                          domProps: {
                                                            value: zip.cap
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                        " +
                                                              _vm._s(zip.cap) +
                                                              "\r\n                      "
                                                          )
                                                        ]
                                                      )
                                                    })
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "zip" }
                                                  },
                                                  [_vm._v("Cap")]
                                                ),
                                                _vm._v(" "),
                                                _vm.zipsState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id: "loadZips",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.zip")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.zip"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.adress,
                                                      expression: "adress"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 128,
                                                        min: 5
                                                      },
                                                      expression:
                                                        "{required:true, max: 128, min: 5}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.adress"
                                                    ),
                                                    valid: !!_vm.adress
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "adress",
                                                    name: "adress",
                                                    "data-vv-as": "Indirizzo"
                                                  },
                                                  domProps: {
                                                    value: _vm.adress
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.adress =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "adress" }
                                                  },
                                                  [_vm._v("Indirizzo")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.adress")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.adress"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.civic,
                                                      expression: "civic"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 15,
                                                        min: 1
                                                      },
                                                      expression:
                                                        "{required:true, max: 15, min: 1}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.civic"
                                                    ),
                                                    valid: !!_vm.civic
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "civic",
                                                    name: "civic",
                                                    "data-vv-as": "Civico"
                                                  },
                                                  domProps: {
                                                    value: _vm.civic
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.civic =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "civic" }
                                                  },
                                                  [_vm._v("Civico")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.civic")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.civic"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _vm.client_type !=
                                            "Amministratore di condominio" /*&& to_get_cadastral_data != '1'*/
                                              ? _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "widthFull center black pb-0"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\r\n            Dati Catastali\r\n          "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.client_type !=
                                        "Amministratore di condominio" /*&& to_get_cadastral_data != '1'*/
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-4 mb-3 " },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.foglio,
                                                          expression: "foglio"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            max: 10,
                                                            min: 1
                                                          },
                                                          expression:
                                                            "{required:true,  max: 10, min: 1}"
                                                        }
                                                      ],
                                                      ref: "foglio",
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-1.foglio"
                                                        ),
                                                        valid: !!_vm.foglio
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        id: "foglio",
                                                        name: "foglio",
                                                        "data-vv-as": "foglio"
                                                      },
                                                      domProps: {
                                                        value: _vm.foglio
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.foglio =
                                                            $event.target.value
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: { for: "foglio" }
                                                      },
                                                      [_vm._v("Foglio")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-1.foglio"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n              " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-1.foglio"
                                                                  )
                                                                ) +
                                                                "\r\n            "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.client_type !=
                                        "Amministratore di condominio" /*&& to_get_cadastral_data != '1'*/
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-4 mb-3 " },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.particella,
                                                          expression:
                                                            "particella"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            max: 10,
                                                            min: 1
                                                          },
                                                          expression:
                                                            "{required:true, max: 10, min: 1}"
                                                        }
                                                      ],
                                                      ref: "particella",
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-1.particella"
                                                        ),
                                                        valid: !!_vm.particella
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        id: "particella",
                                                        name: "particella",
                                                        "data-vv-as":
                                                          "particella"
                                                      },
                                                      domProps: {
                                                        value: _vm.particella
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.particella =
                                                            $event.target.value
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: "particella"
                                                        }
                                                      },
                                                      [_vm._v("Particella")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-1.particella"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n              " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-1.particella"
                                                                  )
                                                                ) +
                                                                "\r\n            "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.client_type !=
                                        "Amministratore di condominio" /*&& to_get_cadastral_data != '1'*/
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-4 mb-3 " },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.subalterno,
                                                          expression:
                                                            "subalterno"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            max: 10,
                                                            min: 1
                                                          },
                                                          expression:
                                                            "{required: true, max: 10, min: 1}"
                                                        }
                                                      ],
                                                      ref: "subalterno",
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-1.subalterno"
                                                        ),
                                                        valid: !!_vm.subalterno
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        id: "subalterno",
                                                        name: "subalterno",
                                                        "data-vv-as":
                                                          "subalterno"
                                                      },
                                                      domProps: {
                                                        value: _vm.subalterno
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.subalterno =
                                                            $event.target.value
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: "subalterno"
                                                        }
                                                      },
                                                      [_vm._v("Subalterno")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-1.subalterno"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n              " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-1.subalterno"
                                                                  )
                                                                ) +
                                                                "\r\n            "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        })
                                      ])
                                    ]
                                  )
                                : _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row " }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                    LISTA DOCUMENTI\r\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4005bb1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4005bb1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calcolatore/agnellimetalli.vue
// module id = null
// module chunks = 